var $30a099a3f19b59af$exports = {};
$30a099a3f19b59af$exports = {
    "pending": `u tijeku`
};


export {$30a099a3f19b59af$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
